// extracted by mini-css-extract-plugin
export default {"deleteItem":"iWftf0U","deleteItemIcon":"ANCLgSx XmGonBy"};